import { render, staticRenderFns } from "./serviceSale.vue?vue&type=template&id=3bbc97dc&scoped=true&"
import script from "./serviceSale.vue?vue&type=script&lang=js&"
export * from "./serviceSale.vue?vue&type=script&lang=js&"
import style0 from "./serviceSale.vue?vue&type=style&index=0&id=3bbc97dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc97dc",
  null
  
)

export default component.exports